module.exports = __webpack_public_path__ + "static/3fbfad3b-a48c-48fd-a9e5-40fe37b5bed3-500.aa8ed00b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/good-sheperd/3fbfad3b-a48c-48fd-a9e5-40fe37b5bed3-500.jpg
// module id = 976
// module chunks = 168707334958949